"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var store_1 = require("@ngrx/store");
var skynet_store_locales_api_1 = require("@synisys/skynet-store-locales-api");
var skynet_store_utilities_1 = require("@synisys/skynet-store-utilities");
var lodash_1 = require("lodash");
var moment = require("moment");
var operators_1 = require("rxjs/operators");
require('moment-jdateformatparser');
var FormattingService = /** @class */ (function () {
    function FormattingService(store) {
        this.store = store;
    }
    FormattingService_1 = FormattingService;
    FormattingService.resolveTimezone = function (timezoneOffset) {
        if (lodash_1.isNil(timezoneOffset)) {
            return -new Date().getTimezoneOffset();
        }
        else {
            return timezoneOffset / 60;
        }
    };
    FormattingService.getLocale = function (language, country) {
        return language + '-' + country;
    };
    FormattingService.prototype.formatDate = function (utcTime) {
        return this.getCurrentLocale().pipe(operators_1.map(function (localeInfo) {
            var date = moment(utcTime).utcOffset(0);
            date.locale(FormattingService_1.getLocale(localeInfo.locale, localeInfo.country));
            return date.formatWithJDF(localeInfo.datePattern);
        }));
    };
    FormattingService.prototype.formatTime = function (utcTime) {
        return this.getCurrentLocale().pipe(operators_1.map(function (localeInfo) {
            var date = moment(utcTime).utcOffset(FormattingService_1.resolveTimezone(localeInfo.timeZoneOffset));
            date.locale(FormattingService_1.getLocale(localeInfo.locale, localeInfo.country));
            return date.formatWithJDF(localeInfo.timePattern);
        }));
    };
    FormattingService.prototype.formatDateTime = function (utcTime) {
        return this.getCurrentLocale().pipe(operators_1.map(function (localeInfo) {
            var date = moment(utcTime).utcOffset(FormattingService_1.resolveTimezone(localeInfo.timeZoneOffset));
            date.locale(FormattingService_1.getLocale(localeInfo.locale, localeInfo.country));
            return date.formatWithJDF(localeInfo.datePattern + ' ' + localeInfo.timePattern);
        }));
    };
    FormattingService.prototype.formatNumber = function (number, options) {
        return this.getCurrentLocale().pipe(operators_1.map(function (localeInfo) {
            var numberFormat = __assign({}, localeInfo.numberFormat, options);
            var str = Boolean(numberFormat.fractionDigits)
                ? number.toFixed(numberFormat.fractionDigits)
                : String(number);
            var groupIndent = /\B(?=(\d{3})+(?!\d))/g;
            if (str.includes('.')) {
                var parts = str.split('.');
                return (parts[0].replace(groupIndent, numberFormat.groupSeparator) +
                    numberFormat.decimalSeparator +
                    parts[1]);
            }
            else {
                return str.replace(groupIndent, numberFormat.groupSeparator);
            }
        }));
    };
    FormattingService.prototype.parseNumber = function (num) {
        return this.getCurrentLocale().pipe(operators_1.map(function (localeInfo) {
            return parseFloat(num
                .replace(new RegExp('[^\\{separator}0-9]+'.replace('{separator}', localeInfo.numberFormat.decimalSeparator), 'g'), '')
                .replace(localeInfo.numberFormat.decimalSeparator, '.'));
        }), operators_1.map(function (value) { return (isNaN(value) ? undefined : value); }));
    };
    FormattingService.prototype.getCurrentLocale = function () {
        var _this = this;
        return this.store
            .select(function (state) { return state.languages.currentLanguageId; })
            .pipe(operators_1.filter(skynet_store_utilities_1.notNil), operators_1.switchMap(function (currentLanguageId) {
            return skynet_store_locales_api_1.localeStoreManager.selectOne(_this.store, currentLanguageId);
        }), operators_1.filter(skynet_store_utilities_1.notNil));
    };
    FormattingService = FormattingService_1 = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [store_1.Store])
    ], FormattingService);
    return FormattingService;
    var FormattingService_1;
}());
exports.FormattingService = FormattingService;
//# sourceMappingURL=formating.service.js.map